class ToggleAgreeReason {
	constructor(config) {
		this.config = Object.assign({
			agreeSelect: '[data-selector="agree"]',
			agreeReasonContainer: '[data-container="agree-reason"]'
		}, config);

		if ($(this.config.agreeSelect).length > 0) {
			this.init();
		}
	}

	init() {
		this.toggleAgreeReason();
		$(this.config.agreeSelect).on('change', () => this.toggleAgreeReason());
	}

	toggleAgreeReason() {
		if ($(this.config.agreeSelect).val() === 'nee') {
			$(this.config.agreeReasonContainer).show();
		} else {
			$(this.config.agreeReasonContainer).hide();
		}
	}
}

$(document).ready(function() {
	new ToggleAgreeReason();
});